import React from 'react';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';
import {AntiNukeFeatureBig} from '../../Cards/AntiNukeFeatureBig';
import {AntiNukeFeature} from '../../Cards/AntiNukeFeature';

export const AntiNuke = () => {
  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Anti-Nuke"
        subTitle="The bot constantly observes all members and develops a consistent pattern of behaviour. The bot isolates a member if a divergence occurs until the server owner arrives."
        labelTitle="Anti-Nuke Tutorial"
        labelLInk={featuresLinks.antiNuke}
      />
      <div className={styles.block}>
        <div className={styles.mobWrapper}>
          <AntiNukeFeature second />
        </div>
        <div className={styles.deskWrapper}>
          <AntiNukeFeatureBig />
        </div>
      </div>
    </div>
  );
};
